import { App } from 'vue'
import QuillEditor from './quill-editor.vue'
import FooterBar from './footer-bar.vue'
import ImageItem from './image-item.vue'
import QrCode from './qr-code.vue'

// 注册全局组件
const useGlobalComponent = (app: App): void => {
  app.component('QuillEditor', QuillEditor)
  app.component('FooterBar', FooterBar)
  app.component('ImageItem', ImageItem)
  app.component('QrCode', QrCode)
}

export {
  useGlobalComponent
}
